define(["require", "exports"], function (require, exports) {
    "use strict";
    // starts with: (year)-(month)-(seconds)T(hours):(minutes):(seconds)(optional: .(miliseconds))
    var isoPattern = /^(\d{4})-(\d{2})-(\d{2})(T(\d{2}):(\d{2}):(\d{2})(\.(\d{3}))?)?/;
    var second = 1000;
    var minute = 60 * second;
    var hour = 60 * minute;
    var day = 24 * hour;
    function pad(n) {
        return (n < 10) ? ("0".concat(n)) : n;
    }
    var dateUtils = /** @class */ (function () {
        function dateUtils() {
        }
        dateUtils.addDays = function (date, value) {
            return new Date(date.getTime() + (value * day));
        };
        dateUtils.addHours = function (date, value) {
            return new Date(date.getTime() + (value * hour));
        };
        dateUtils.addMinutes = function (date, value) {
            return new Date(date.getTime() + (value * minute));
        };
        dateUtils.addSeconds = function (date, value) {
            return new Date(date.getTime() + (value * second));
        };
        dateUtils.addMonths = function (date, value) {
            var dateCopy = new Date(date.getTime());
            var n = dateCopy.getDate();
            dateCopy.setDate(1);
            dateCopy.setMonth(dateCopy.getMonth() + value * 1);
            dateCopy.setDate(Math.min(n, dateUtils.getDaysInMonth(dateCopy.getFullYear(), dateCopy.getMonth())));
            return dateCopy;
        };
        dateUtils.getDaysInMonth = function (year, month) {
            return [31, (dateUtils.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
        };
        dateUtils.isLeapYear = function (year) {
            return ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
        };
        dateUtils.firstDayOfYear = function () {
            var d = dateUtils.today();
            return new Date(d.getFullYear(), 0, 1);
        };
        dateUtils.firstDayOfQuarter = function () {
            var d = dateUtils.today();
            var quarter = dateUtils.getQuarter(d);
            var firstMonth = quarter === 1 ? 9 : quarter === 2 ? 0 : quarter === 3 ? 3 : quarter === 4 ? 6 : 1;
            return new Date(d.getFullYear(), firstMonth, 1);
        };
        dateUtils.firstDayOfMonth = function (date) {
            var d = date || dateUtils.today();
            return new Date(d.getFullYear(), d.getMonth(), 1);
        };
        dateUtils.firstDayOfWeek = function (date) {
            var d = date || dateUtils.today();
            return dateUtils.addDays(d, dateUtils.firstDay - d.getDay());
        };
        // For the US Government fiscal year
        // Oct-Dec = 1
        // Jan-Mar = 2
        // Apr-Jun = 3
        // Jul-Sep = 4
        dateUtils.getQuarter = function (d) {
            d = d || new Date();
            var m = Math.floor(d.getMonth() / 3) + 2;
            return m > 4 ? m - 4 : m;
        };
        dateUtils.isDate = function (value) {
            return Object.prototype.toString.call(value) === "[object Date]";
        };
        dateUtils.isIsoDate = function (value) {
            return isoPattern.test(value);
        };
        dateUtils.lastDayOfYear = function () {
            var d = dateUtils.today();
            return new Date(d.getFullYear(), 12, 0);
        };
        dateUtils.lastDayOfQuarter = function () {
            var d = dateUtils.today();
            var quarter = dateUtils.getQuarter(d);
            var lastMonth = quarter === 1 ? 11 : quarter === 2 ? 2 : quarter === 3 ? 5 : quarter === 4 ? 8 : 11;
            return new Date(d.getFullYear(), lastMonth, 1);
        };
        dateUtils.lastDayOfMonth = function (date) {
            var d = date || dateUtils.today();
            return new Date(d.getFullYear(), d.getMonth() + 1, 0);
        };
        dateUtils.lastDayOfWeek = function (date) {
            var d = date || dateUtils.today();
            return dateUtils.addDays(d, 6 + dateUtils.firstDay - d.getDay());
        };
        dateUtils.now = function () {
            return new Date();
        };
        dateUtils.parseIsoDate = function (value) {
            if (!value || dateUtils.isDate(value)) {
                return value;
            }
            if (typeof value !== "string") {
                throw "Expected date string, was: ".concat(typeof value);
            }
            var match = value.match(isoPattern);
            if (!match) {
                throw "Not valid date format. Expected ISO 8601: YYYY-MM-DDThh:mm:ss (.000Z optional), but was: ".concat(value);
            }
            var year = parseInt(match[1], 10);
            var month = parseInt(match[2], 10) - 1;
            var date = parseInt(match[3], 10);
            var hours = parseInt(match[5], 10) || 0;
            var minutes = parseInt(match[6], 10) || 0;
            var seconds = parseInt(match[7], 10) || 0;
            var ms = parseInt(match[9], 10) || 0;
            return new Date(year, month, date, hours, minutes, seconds, ms);
        };
        dateUtils.stripTime = function (date) {
            var dateToStrip = date;
            if (dateUtils.isIsoDate(date.toString())) {
                dateToStrip = dateUtils.parseIsoDate(date);
            }
            return new Date(dateToStrip.getFullYear(), dateToStrip.getMonth(), dateToStrip.getDate());
        };
        dateUtils.secondsToTime = function (seconds) {
            var startHours = ~~(seconds / 3600);
            var startMin = Math.round((seconds % 3600) / 60);
            var startMinFormatted = (startMin < 10 ? "0" : "") + startMin;
            if (dateUtils.is24HourFormat) {
                return startHours + ":" + startMinFormatted;
            }
            var ampm = startHours < 12 ? " AM" : " PM";
            if (startHours > 12) {
                startHours -= 12;
            }
            return startHours + ":" + startMinFormatted + ampm;
        };
        dateUtils.secondsToDuration = function (sec_num) {
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = Math.round(sec_num) - (hours * 3600) - (minutes * 60);
            var time = pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
            return time;
        };
        dateUtils.millisecondsToDuration = function (sec_num) {
            sec_num = sec_num / 1000;
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = Math.round(sec_num - (hours * 3600) - (minutes * 60));
            var time = pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
            return time;
        };
        dateUtils.timeStringFromDate = function (date) {
            var startHours = pad(date.getHours());
            var startMin = pad(date.getMinutes());
            var ampm = +startHours < 12 ? " AM" : " PM";
            if (startHours > 12) {
                startHours -= 12;
            }
            return +startHours + ":" + startMin + ampm;
        };
        dateUtils.secondsToHours = function (seconds, addUnit) {
            var startHours = ~~(seconds / 3600);
            var startMin = Math.round((seconds % 3600) / 60);
            var startMinFormatted = (startMin < 10 ? "0" : "") + startMin;
            return startHours + ":" + startMinFormatted + (addUnit ? " hr" : "");
        };
        dateUtils.today = function () {
            return dateUtils.stripTime(dateUtils.now());
        };
        dateUtils.tomorrow = function () {
            return dateUtils.stripTime(dateUtils.addDays(dateUtils.now(), 1));
        };
        dateUtils.toIsoString = function (date) {
            if (date) {
                return date.getFullYear() +
                    "-" + pad(date.getMonth() + 1) +
                    "-" + pad(date.getDate()) +
                    "T" + pad(date.getHours()) +
                    ":" + pad(date.getMinutes()) +
                    ":" + pad(date.getSeconds()) +
                    "." + (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
            }
            return null;
        };
        dateUtils.toIsoStringDate = function (date) {
            if (date) {
                return date.getFullYear() +
                    "-" + pad(date.getMonth() + 1) +
                    "-" + pad(date.getDate());
            }
            return null;
        };
        dateUtils.is24HourFormat = function () {
            /*var timeFormat = kendo.culture().calendar.patterns['t'].toLowerCase();
    
            return timeFormat.toLocaleLowerCase().indexOf("tt") == -1;*/
            return false;
        };
        dateUtils.humanizeDate = function (date, defaultDateFormat, defaultTimeFormat) {
            if (defaultDateFormat === void 0) { defaultDateFormat = "g"; }
            if (defaultTimeFormat === void 0) { defaultTimeFormat = "HH:mm"; }
            var today = new Date();
            var todayNew = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
            var lastweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
            var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var newdate = new Date(date);
            if (newdate.getTime() >= todayNew.getTime()) {
                return "Today ".concat(kendo.toString(newdate, defaultTimeFormat));
            }
            if (newdate.getTime() < todayNew.getTime() && newdate.getTime() >= yesterday.getTime()) {
                return "Yesterday ".concat(kendo.toString(newdate, defaultTimeFormat));
            }
            if (newdate.getTime() < yesterday.getTime() && newdate.getTime() >= lastweek.getTime()) {
                return "".concat(weekday[newdate.getDay()], " ").concat(kendo.toString(newdate, defaultTimeFormat));
            }
            return kendo.toString(newdate, defaultDateFormat);
        };
        // The first day of the week (0 = Sunday, 1 = Monday, etc)
        dateUtils.firstDay = 0;
        return dateUtils;
    }());
    (window["global"] || (window["global"] = {})).dateUtils = dateUtils;
    return dateUtils;
});
//# sourceMappingURL=dateUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/dateUtils.js
// module id = 10
// module chunks = 2